import { List } from "immutable";
import { MobileBaseObject } from "./mobile-base-object";
import { UserCheckIn } from "./userCheckIn";

export interface IUserMapping extends MobileBaseObject {
  userID: string;
  loginID: string;
  name: string;
  currentAirportID: string;
  airports: string;
  skills: string;
  employmentNumber: string;
  userCheckIn: UserCheckIn;

  loggedIn: boolean;
}

export class UserMapping extends MobileBaseObject implements IUserMapping {

  public userID: string;
  public loginID: string;
  public name: string;
  public currentAirportID: string;
  public airports: string;
  public skills: string;
  public employmentNumber: string;
  public userCheckIn: UserCheckIn;
  public deleted: boolean;
  public loggedIn: boolean;

  public constructor(userMapping: Partial<IUserMapping> = null) {
    super();

    if (userMapping != null) {
      this.userID = userMapping.userID;
      this.loginID = userMapping.loginID;
      this.name = userMapping.name;
      this.currentAirportID = userMapping.currentAirportID;
      this.airports = userMapping.airports;
      this.skills = userMapping.skills;
      this.employmentNumber = userMapping.employmentNumber;
      this.userCheckIn = userMapping.userCheckIn;
      this.deleted = userMapping.deleted;
      this.loggedIn = userMapping.loggedIn;

      this.id = userMapping.id;
      this.version = userMapping.version;
      this.createdAt = userMapping.createdAt;
      this.updatedAt = userMapping.updatedAt;
      this.version = userMapping.version;
    }
  }

  public get airportsExpanded(): List<string> {
    if(this.airports)
      return JSON.parse(this.airports) as List<string>;
    return JSON.parse('[]') as List<string>;;
  }

  public set airportsExpanded(value: List<string>) {
    this.airports = JSON.stringify(value);
  }

  public get skillsExpanded(): List<string> {
    if(this.skills)
      return JSON.parse(this.skills) as List<string>;

    return JSON.parse('[]') as List<string>;;
  }
  public set skillsExpanded(value: List<string>) {
    this.skills = JSON.stringify(value);
  }

}
